import CopySitesModal from './CopySitesModal'

export default CopySitesModal
